<script>
    import router from "page";
    import { onMount } from "svelte";
    import { tick } from "svelte";

    import Login from "./authentication/Login.svelte";

    import Loader from "./components/Loader.svelte";
    import Message from "./components/Message.svelte";

    import Admin from "./admin/Admin.svelte";

    import Navigation from "./layout/Navigation.svelte";
    import Categories from "./layout/Categories.svelte";

    import Dashboard from "./pages/Dashboard.svelte";
    import User from "./pages/User.svelte";

    import Brands from "./pages/Brands.svelte";
    import Products from "./pages/Products.svelte";
    import Product from "./pages/Product.svelte";

    import Orders from "./pages/Orders.svelte";
    import Order from "./pages/Order.svelte";
    import Invoices from "./pages/Invoices.svelte";
    import Invoice from "./pages/Invoice.svelte";

    import Cart from "./pages/Cart.svelte";

    import Modal from "./components/Modal.svelte";

    import { fetchGet } from "./utils/utilsFetch.js";

    import {
        isAuthenticated,
        isAdmin,
        activePage,
        client,
        user,
        locale,
        cart,
        isLoading,
        searchArray,
        isMobile,
        showSidebar,
        productModalSku,
        showProductModal,
    } from "./stores.js";

    import { getDecodedToken } from "./utils/utils.js";

    let authRoute, authPage, page, props;

    function isValidToken() {
        let isValid = false;
        let token = getDecodedToken();

        if (token && Date.now() <= token.exp * 1000) {
            isValid = true;
            $isAdmin = token.isAdmin;
        } else {
            localStorage.removeItem("token");
        }

        return isValid;
    }

    async function authenticationMiddleware(ctx, next) {
        if (isValidToken()) {
            $isAuthenticated = true;

            next();
        } else {
            switch (ctx.pathname) {
                case "/login":
                    authPage = Login;
                    break;

                default:
                    authPage = Login;
            }
        }
    }

    router("*", authenticationMiddleware);

    async function utilsMiddleware(ctx, next) {
        $isLoading = true;

        $isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        console.log("$ISMOBILE", $isMobile);

        if ($isMobile) {
            $showSidebar = false;
        }

        if (!$user) {
            $user = await fetchGet("/api/user");
        }

        if (!$locale) {
            $locale = await fetchGet(`/api/locales/${$user.languageCode}`);
        }

        [$client, $cart] = await Promise.all([
            fetchGet("/api/client"),
            fetchGet("/api/cart"),
        ]);

        $isLoading = false;
        $showProductModal = false;

        next();
    }

    router("*", utilsMiddleware);

    // PRODUCTS SEARCHBY ========================================================

    // onMount(async () => {
    //     $isLoading = true;

    //     let searchByParts = await fetchGet(`/api/products/search`);

    //     $searchArray = searchByParts.map((item) => {
    //         return {
    //             sku: item.sku,
    //             name: `${item.sku} - ${item.name}`,
    //             searchBy: `${item.sku} ${item.name} ${item.barcodes}`,
    //         };
    //     });

    //     // console.log("$searchArray", $searchArray);

    //     $isLoading = false;
    // });

    // GENERAL ========================================================

    router("/", async (ctx) => {
        $activePage = "";
        page = Dashboard;
    });

    router("/user", async (ctx) => {
        $activePage = "user";
        page = User;
    });

    router("/brands", async (ctx) => {
        $activePage = "brands";
        page = Brands;
    });

    router("/products", async (ctx) => {
        $activePage = "products";
        console.log(ctx);
        props = {
            querystring: ctx.querystring,
        };
        page = Products;
    });

    router("/products/:sku", async (ctx) => {
        $activePage = "product";
        props = {
            sku: ctx.params.sku,
        };
        page = Product;
    });

    router("/orders", async (ctx) => {
        $activePage = "orders";
        page = Orders;
    });

    router("/orders/:orderKey", async (ctx) => {
        $activePage = "orders";
        props = {
            orderKey: ctx.params.orderKey,
        };
        page = Order;
    });

    router("/invoices", async (ctx) => {
        $activePage = "invoices";
        page = Invoices;
    });

    router("/invoices/:invoiceKey", async (ctx) => {
        $activePage = "invoices";
        props = {
            invoiceKey: ctx.params.invoiceKey,
        };
        page = Invoice;
    });

    router("/cart", async (ctx) => {
        $activePage = "cart";
        page = Cart;
    });

    router();
</script>

<svelte:head>
    <title>B2B Office Plus - {$activePage}</title>

    <link
        rel="stylesheet"
        href="https://use.fontawesome.com/releases/v5.8.2/css/all.css"
        integrity="sha384-oS3vJWv+0UjzBfQzYUhtDYW+Pj2yciDJxpsK1OYPAYjqT085Qq/1cq5FLXAZQ7Ay"
        crossorigin="anonymous"
    />
</svelte:head>

<Modal bind:showModal={$showProductModal}>
    <div slot="title">
        {$locale?.productPreview || ""} - <a href="/products/{$productModalSku}">
            {$locale?.linkToProduct || ""}
        </a>
    </div>
    <div slot="body">
        <Product bind:sku={$productModalSku} />
    </div>
</Modal>

<!-- Prevents flashing the login screen -->
{#if $isAuthenticated}
    <div class="container">
        {#if $isAdmin}
            <Navigation />
            <div class="content-full">
                <Admin />
            </div>
        {:else}
            <Message />
            <Loader />
            <Navigation />
            <Categories />
            <div
                class:content={$showSidebar}
                class:content-full={!$showSidebar}
            >
                <svelte:component this={page} {...props} />
            </div>
        {/if}
    </div>
{:else}
    <svelte:component this={authPage} {...props} />
{/if}

<style>
    .container {
        height: 100%;
        display: grid;
        grid-template-columns: 200px 1fr;
        grid-template-rows: 50px calc(100vh - 50px);
    }

    .content {
        grid-column: 2/-1;
        grid-row: 2/-1;
        overflow: auto;
    }

    .content-full {
        grid-column: 1/-1;
        grid-row: 2/-1;
    }

    a {
        color: blue;
        text-decoration: underline;
    }

    @media only screen and (max-device-width: 600px) {
        .container {
            grid-template-rows: 50px calc(100vh - 50px);
        }
    }
</style>
